import { useQuery } from '@tanstack/react-query'
import { apiFetch, hasLiveApi } from '@/api/client'
import { isUnreachableApiError } from '@/api/unreachable'
import { enrichTreeAccounts } from '@/api/map/downline'
import type { AgentNode } from '@/api/map/agent'
import * as api from '@/data/api'
import type { Account } from '@/data/types'
import { keys } from '@/api/hooks/shared/keys'

async function listChildrenLive(parentId: string): Promise<Account[]> {
  const tree = await apiFetch<AgentNode[]>(`/v1/agents/${parentId}/tree`)
  const accounts = enrichTreeAccounts(tree)
  return accounts
    .filter((a) => a.parentId === parentId)
    .sort((a, b) => a.username.localeCompare(b.username, 'en-IN'))
}

async function listChildren(parentId: string): Promise<Account[]> {
  if (hasLiveApi()) {
    try {
      return await listChildrenLive(parentId)
    } catch (err) {
      if (isUnreachableApiError(err)) return []
      throw err
    }
  }
  return api.listChildren(parentId)
}

export function useChildren(parentId: string | undefined) {
  return useQuery({
    queryKey: keys.children(parentId ?? ''),
    queryFn: () => listChildren(parentId!),
    enabled: Boolean(parentId),
  })
}
